import { startMeUp } from "#scripts/startscript.js";
import { ReadAimCookes } from "#scripts/cookie_control";
import deepmerge from "#scripts/tools/deepMerge";

// Style
import "#src/style/style.scss";
import "@digdir/designsystemet-css/index.css";

const urlParams = new URLSearchParams(window.location.search.replace("?", "").toLowerCase());
if (urlParams.get("runtimemode") !== null) {
	document.cookie = `RuntimeMode=${urlParams.get("runtimemode")}`;
}
if (urlParams.get("runtimedeveloper") !== null) {
	document.cookie = `RuntimeDeveloper=${urlParams.get("runtimedeveloper")}`;
}

if (window.location.href.match(/\?dev/gi)) {
	window.cmsUrl = "https://aim-admin-qa.azurewebsites.net";
	window.dev = true;
}

window.AimCookies = ReadAimCookes();
window.fetchCounter = 0;
window.startTime = Date.now();

window.getUrlAttr = (attr) => new URL(window.location.href).searchParams.get(attr);
window.apiUrl = ["dev", "qa", "staging", "release", "preprod"].includes(window.AimCookies.RuntimeMode)
	? `https://prokom-aimcms-${window.AimCookies.RuntimeMode}.azurewebsites.net/api`
	: "https://prokom-aimcms.azurewebsites.net/api";

if (window.AimCookies.RuntimeMode === "local") {
	window.apiUrl = "https://localhost:44351/api";
}
window.cmsUrl = "https://aim-admin.azurewebsites.net";



if (window.AimCookies.RuntimeMode !== "prod" && window.AimCookies.RuntimeMode !== undefined) {
	//merge serverdata.configMeta.aim and serverdata.configMeta.aim_dev
	const defaultAimConfig = window.serverdata?.configMeta?.aim;
	const devAimConfig = window.serverdata?.configMeta?.aim_dev;

	if (devAimConfig !== undefined) {
		window.serverdata.configMeta.aim = deepmerge(defaultAimConfig, devAimConfig);
	}
}

window.apiUrl = window.serverdata?.configMeta?.aim?.useLocalApiPath ? "/api/aim" : window.apiUrl;

if (urlParams.get("devstyles") !== null) {
	document.cookie = `DevStyles=${urlParams.get("devstyles")}`;
	window.AimCookies.DevStyles = urlParams.get("devstyles");
}

const mode = window.AimCookies?.RuntimeMode;
const envConfig = {
	local: {
		label: "Localhost",
		cmsUrl: null,
		dev: true,
		logStyle: "color: #004085; background-color: #cce5ff; font-size: 15px;",
	},
	dev: {
		label: "DEV",
		cmsUrl: "https://aim-admin-dev.azurewebsites.net",
		dev: true,
		logStyle: "color: #004085; background-color: #cce5ff; font-size: 15px;",
	},
	qa: {
		label: "QA",
		cmsUrl: "https://aim-admin-qa.azurewebsites.net",
		dev: true,
		logStyle: "color: #004085; background-color: #cce5ff; font-size: 15px;",
	},
	staging: {
		label: "STAGING",
		cmsUrl: "https://aim-admin-staging.azurewebsites.net",
		dev: true,
		logStyle: "color: #856404; background-color: #fff3cd; font-size: 15px;",
	},
	release: {
		label: "RELEASE",
		cmsUrl: "https://aim-admin-release.azurewebsites.net",
		dev: true,
		logStyle: "color: #856404; background-color: #fff3cd; font-size: 15px;",
	},
	preprod: {
		label: "PREPROD",
		cmsUrl: "https://aim-admin-release.azurewebsites.net",
		dev: true,
		logStyle: "color: #856404; background-color: #fff3cd; font-size: 15px;",
	},
	prod: {
		label: "PROD",
		cmsUrl: "https://aim-admin.azurewebsites.net",
		dev: false,
		logStyle: "color: #856404; background-color: #fff3cd; font-size: 15px;",
	},
};
const config = envConfig[mode];
if (config) {
	console.log(`%c Entering RuntimeMode: ${config.label} `, config.logStyle);
	if (config.cmsUrl) window.cmsUrl = config.cmsUrl;
	window.dev = config.dev;
}

window.contentSubscription = "";
window.translation = {};

document.addEventListener("DOMContentLoaded", (event) => {
	if (window.serverdata !== undefined) {
		const meta = JSON.parse(window.serverdata.defaultConfig.result.applications[0].metaData);
		const defaultTranslation = meta.translation;
		const customTranslation = window.serverdata?.configMeta?.translation ? window.serverdata?.configMeta?.translation : {};
		window.translation = deepmerge(defaultTranslation, customTranslation);
		startMeUp(event);
	}
});
